import { z } from 'zod';

/** What anyone gets from /health: enough for an uptime check, nothing about the build or the integrations. */
export const PublicHealthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  database: z.enum(['ok', 'unreachable']),
  time: z.iso.datetime(),
});

export type PublicHealthResponse = z.infer<typeof PublicHealthResponseSchema>;

/** Signed-in sessions and the monitor (header x-health-token) get the full body. */
export const HealthResponseSchema = PublicHealthResponseSchema.extend({
  version: z.string(),
  /** failing: 3 failed rounds in a row or a rejected key; stale: no successful round for 24 h; unknown: database down. */
  sync: z.enum(['ok', 'failing', 'stale', 'not_configured', 'unknown']),
  /** failing: two SMTP sends in a row failed or the mailbox could not be read 3 times in a row; not_configured: no mail settings. */
  mail: z.enum(['ok', 'failing', 'not_configured']),
  /** Lexware Office (STE-11). failing: a rejected key or 3 failed bookkeeping rounds in a row; not_configured: no key; unknown: database down. */
  bookkeeping: z.enum(['ok', 'failing', 'not_configured', 'unknown']),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
